// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_request/list_purchase_requests.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PurchaseRequest, RequestStatus } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ListPurchaseRequestsRequest
 */
export class ListPurchaseRequestsRequest extends Message<ListPurchaseRequestsRequest> {
  /**
   * Filter by status of the purchase requests (e.g., pending, approved, rejected)
   *
   * @generated from field: string status = 1;
   */
  status = "";

  /**
   * Page number for pagination
   *
   * @generated from field: int32 page = 2;
   */
  page = 0;

  /**
   * Number of items per page for pagination
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize = 0;

  /**
   * Search term to filter purchase requests by request number or supplier name
   *
   * @generated from field: string search = 4;
   */
  search = "";

  /**
   * Status of the purchase request to filter by
   *
   * @generated from field: com.neulink.pharmacy.RequestStatus request_status = 5;
   */
  requestStatus = RequestStatus.UNSPECIFIED;

  constructor(data?: PartialMessage<ListPurchaseRequestsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListPurchaseRequestsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "request_status", kind: "enum", T: proto3.getEnumType(RequestStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPurchaseRequestsRequest {
    return new ListPurchaseRequestsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPurchaseRequestsRequest {
    return new ListPurchaseRequestsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPurchaseRequestsRequest {
    return new ListPurchaseRequestsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPurchaseRequestsRequest | PlainMessage<ListPurchaseRequestsRequest> | undefined, b: ListPurchaseRequestsRequest | PlainMessage<ListPurchaseRequestsRequest> | undefined): boolean {
    return proto3.util.equals(ListPurchaseRequestsRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ListPurchaseRequestsResponse
 */
export class ListPurchaseRequestsResponse extends Message<ListPurchaseRequestsResponse> {
  /**
   * List of purchase requests matching the criteria
   *
   * @generated from field: repeated com.neulink.pharmacy.PurchaseRequest purchase_requests = 1;
   */
  purchaseRequests: PurchaseRequest[] = [];

  /**
   * Total number of purchase requests matching the criteria
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ListPurchaseRequestsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListPurchaseRequestsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_requests", kind: "message", T: PurchaseRequest, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPurchaseRequestsResponse {
    return new ListPurchaseRequestsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPurchaseRequestsResponse {
    return new ListPurchaseRequestsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPurchaseRequestsResponse {
    return new ListPurchaseRequestsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPurchaseRequestsResponse | PlainMessage<ListPurchaseRequestsResponse> | undefined, b: ListPurchaseRequestsResponse | PlainMessage<ListPurchaseRequestsResponse> | undefined): boolean {
    return proto3.util.equals(ListPurchaseRequestsResponse, a, b);
  }
}

